import { Box, Stack, Typography, theme } from '@dtx-company/design-system/src'
import { PrismicAccordion } from '@dtx-company/app/shared/prismic/src/components/PrismicAccordion/PrismicAccordion'
import { PrismicAccordionSlice } from '@dtx-company/true-common/src/types/PrismicAccordionSlice'
import events from '@dtx-company/inter-app/src/event-tracking/events/miscellaneous'

export const Accordion = ({ primary, items }: PrismicAccordionSlice): JSX.Element => {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      spacing={theme.spacing(6)}
      sx={{
        paddingBottom: theme.spacing(6)
      }}
    >
      <Typography variant="displaySmall" align="center">
        {primary.heading}
      </Typography>
      <Box
        sx={{
          px: theme.spacing(4),
          maxWidth: '900px',
          m: '0 auto'
        }}
      >
        <PrismicAccordion
          items={items}
          onToggledAccordion={events.Core_UseCasePage_Toggled_AccordionItem}
          shouldItemsStartExpanded={true}
        />
      </Box>
    </Stack>
  )
}
